module.exports = __webpack_public_path__ + "static/media/popsicle-top.83b8bcf3.png";